/* eslint-disable */
import React, { useState, useEffect, useRef} from "react";
import { Switch, Route, Redirect } from "react-router-dom";
// creates a beautiful scrollbar
import PerfectScrollbar from "perfect-scrollbar";
import "perfect-scrollbar/css/perfect-scrollbar.css";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import { Assignment, Build, PermContactCalendar, VerifiedUser, Person, Assessment } from "@material-ui/icons/";
// core components
import Navbar from "components/Navbars/Navbar.js";
import Footer from "components/Footer/Footer.js";
import Sidebar from "components/Sidebar/Sidebar.js";
import styles from "assets/jss/material-dashboard-react/layouts/adminStyle.js";

import bgImage from "assets/img/sidebar-2.jpg";
import logo from "assets/img/logo2.png";

import Dashboard from "views/DataAnalysis/Dashboard.js";
import Request from "views/DataAnalysis/Request.js";
import MyRequest from "views/DataAnalysis/MyRequest";
import Admin from "views/DataAnalysis/Admin";
import Goto from "views/DataAnalysis/Goto";
import axios from "axios";


let ps;



const useStyles = makeStyles(styles);

export default function DataAnalysis({ ...rest }) {
  // styles
  const classes = useStyles();
  // ref to help us initialize PerfectScrollbar on windows devices
  const mainPanel = React.createRef();
  // states and functions
  const [image, setImage] = React.useState(bgImage);
  const [color, setColor] = React.useState("blue");
  const [fixedClasses, setFixedClasses] = React.useState("dropdown show");
  const [mobileOpen, setMobileOpen] = React.useState(false);
  const [isHR, setIsHR] = useState(() => {
    try {
      const currentUser = JSON.parse(localStorage.getItem('currentUser'));
      return currentUser && (currentUser.userName === 'madarakung' || currentUser.userName === 'duangdao');
    } catch (e) {
      return false;
    }
  });


const routes = [
  {
      name: "Dashboard ภาพรวม",
      icon: Assessment,
      component: Dashboard,
      layout: "/data-analysis",
      path: "/dashboard",
      hidden: !isHR
  },
  {
      name: "ขอใช้บริการวิเคราะห์ข้อมูล",
      icon: Assignment,
      component: Request,
      layout: "/data-analysis",
      path: "/request",
  }, 
  {
      name: "รายการขอใช้บริการวิเคราะห์ข้อมูลของฉัน",
      icon: PermContactCalendar,
      component: MyRequest,
      layout: "/data-analysis",
      path: "/me",
  }, 
  {
      name: "Admin",
      icon: PermContactCalendar,
      component: Admin,
      layout: "/data-analysis",
      path: "/admin",
      hidden: !isHR
  }
];

const switchRoutes = (
  <Switch>
    {routes.filter(p=>p.hidden==null || p.hidden == false).map((prop, key) => {
     
        return (
          <Route
            //path={(isHR) ? prop.layout + prop.path : "/leave/request"}
            path={prop.layout + prop.path}
            component={prop.component}
            key={key}
          />
        );
      
      return null;
    })}
        <Route path="/data-analysis/id/:ServiceRequestID" component={Goto} />

        <Redirect from="/data-analysis" to="/data-analysis/request" />
  </Switch>
);

  const handleImageClick = image => {
    setImage(image);
  };
  const handleColorClick = color => {
    setColor(color);
  };
  const handleFixedClick = () => {
    if (fixedClasses === "dropdown") {
      setFixedClasses("dropdown show");
    } else {
      setFixedClasses("dropdown");
    }
  };
  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };
  const getRoute = () => {
    return window.location.pathname !== "/admin/maps";
  };
  const resizeFunction = () => {
    if (window.innerWidth >= 960) {
      setMobileOpen(false);
    }
  };
  // initialize and destroy the PerfectScrollbar plugin
  React.useEffect(() => {
    if (navigator.platform.indexOf("Win") > -1) {
      ps = new PerfectScrollbar(mainPanel.current, {
        suppressScrollX: true,
        suppressScrollY: false
      });
      document.body.style.overflow = "hidden";
    }
    window.addEventListener("resize", resizeFunction);

    axios({
      method: 'post',
      url: "/api/v1/currentdate"
    })
    .then(
       result => {
          var currentUser = JSON.parse(localStorage.getItem('currentUser'))
          if(currentUser.userName == 'madarakung' || currentUser.userName == 'duangdao'){
            setIsHR(true);
          }
        },
        error => {console.log(error);}
    );  
    // Specify how to clean up after this effect:
    return function cleanup() {
      if (navigator.platform.indexOf("Win") > -1) {
        ps.destroy();
      }
      window.removeEventListener("resize", resizeFunction);
    };
  }, [mainPanel]);
  return (
    <div className={classes.wrapper}>
      <Sidebar
        routes={routes}
        logoText={"ระบบขอใช้บริการวิเคราะห์ข้อมูลงานวิจัย"}
        logo={logo}
        image={image}
        handleDrawerToggle={handleDrawerToggle}
        open={mobileOpen}
        color={color}
        {...rest}
      />
      <div className={classes.mainPanel} ref={mainPanel}>
        <Navbar
          routes={routes}
          handleDrawerToggle={handleDrawerToggle}
          {...rest}
        />
        {getRoute() ? (
          <div className={classes.content}>
            <div className={classes.container}>{switchRoutes}</div>
          </div>
        ) : (
          <div className={classes.map}>{switchRoutes}</div>
        )}
        {getRoute() ? <Footer /> : null}
      </div>
    </div>
  );
}
